const commonUpdateSettingsSchema = {
  type: 'object',
  properties: {
    updateStrategy: { type: 'string' },
    forceUpdate: { type: 'boolean' },
    allowTags: { type: 'string', pattern: '^regexp:.+' },
    ignoreTags: {
      type: 'array',
      items: { type: 'string' },
    },
    platforms: {
      type: 'array',
      items: { type: 'string' },
    },
  },
  additionalProperties: false,
};

const manifestTargetsSchema = {
  type: 'object',
  properties: {
    helm: {
      type: 'object',
      properties: {
        name: { type: 'string', minLength: 1 },
        tag: { type: 'string', minLength: 1 },
        spec: { type: 'string', minLength: 1 },
      },
      additionalProperties: false,
    },
    kustomize: {
      type: 'object',
      properties: {
        name: { type: 'string', minLength: 1 },
      },
      required: ['name'],
      additionalProperties: false,
    },
  },
  additionalProperties: false,
};

const imageEntrySchema = {
  type: 'object',
  properties: {
    name: { type: 'string', minLength: 1 },
    alias: { type: 'string', minLength: 1 },
    commonUpdateSettings: commonUpdateSettingsSchema,
    manifestTargets: manifestTargetsSchema,
  },
  required: ['name'],
  additionalProperties: false,
};

export const imagesSchema = {
  type: 'object',
  properties: {
    images: {
      type: 'array',
      items: imageEntrySchema,
      minItems: 1,
    },
  },
  required: ['images'],
  additionalProperties: false,
};
